import React, {FC, useMemo} from 'react';
import styles from './MigrationBanner.module.less';

const SUPPORT_EMAIL = 'support@marketplace.autura.com';
const SUPPORT_PHONE = '(888) 998-6085';
const SUPPORT_EMAIL_URL =
    'https://support.marketplace.autura.com/hc/en-us/articles/7305888134925-support-marketplace-autura-com';
const SUPPORT_PHONE_URL = 'https://support.marketplace.autura.com/hc/en-us/articles/7305850019981--888-998-6085';

function formatAvailabilityDate(isoString: string): string {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) {
        return '';
    }

    const now = new Date();
    const isToday =
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();

    const timeStr = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short',
    });

    if (isToday) {
        return `today at ${timeStr}`;
    }

    const dateStr = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });

    return `on ${dateStr} at ${timeStr}`;
}

interface MigrationBannerProps {
    plannedAvailabilityTs: string;
}

const MigrationBanner: FC<MigrationBannerProps> = ({plannedAvailabilityTs}) => {
    const dateText = useMemo(() => formatAvailabilityDate(plannedAvailabilityTs), [plannedAvailabilityTs]);

    return (
        <div className={styles.banner}>
            <div className={styles.content}>
                <span>
                    The new platform is expected to be available {dateText || 'soon'}. We appreciate your patience. If
                    you have questions, please contact support at{' '}
                    <a href={SUPPORT_EMAIL_URL} target="_blank" rel="noopener noreferrer" className={styles.link}>
                        {SUPPORT_EMAIL}
                    </a>{' '}
                    or{' '}
                    <a href={SUPPORT_PHONE_URL} target="_blank" rel="noopener noreferrer" className={styles.link}>
                        {SUPPORT_PHONE}
                    </a>
                    .
                </span>
            </div>
        </div>
    );
};

export default MigrationBanner;
